import { APIClient, ApiQueryParams } from '@frontend/api-utils';
import { Barcode, BarcodeListResponse, BarcodeQueryParams, CreateBarcode, GenerateBarcode, UpdateBarcode } from '@frontend/bpost/types';

const endpoint = '/bpost-api/v1';

export class BpostBarcodeClient extends APIClient {
    public static async fetchBarcodes(queryParams?: ApiQueryParams<BarcodeQueryParams>): Promise<BarcodeListResponse> {
        return await this.apiPaginated<BarcodeListResponse, BarcodeQueryParams>(`${endpoint}/barcodes`, queryParams);
    }

    public static async generateBarcode(accountId: string, barcodeInfo: GenerateBarcode): Promise<Barcode> {
        const response = await this.post(`${endpoint}/accounts/${accountId}/generate-barcode`, barcodeInfo);
        return await this.handleResponse<Barcode>(response);
    }

    public static async patchBarcode(accountId: string, barcodeId: string, barcode: UpdateBarcode): Promise<Barcode> {
        const response = await this.patch(`${endpoint}/accounts/${accountId}/barcodes/${barcodeId}`, barcode);
        return await this.handleResponse<Barcode>(response);
    }

    public static async postBarcode(accountId: string, barcode: CreateBarcode): Promise<Barcode> {
        const response = await this.post(`${endpoint}/accounts/${accountId}/barcodes`, barcode);
        return await this.handleResponse<Barcode>(response);
    }
}